module.exports = __webpack_public_path__ + "img/hz4.a2eb1f58.png";